/**
 * AgentOrdinary's canonical first-party company catalog.
 * A brand card is not a connector, authentication grant or employee entitlement.
 * Keep historical DB keys stable while using the approved one-word brand names.
 */
export type CompanyBrand={
 key:string;name:string;asset:string|null;assetKind:'logo'|'artwork'|'placeholder';
 category:string;initial:string;
 /** Destination URL is optional and does not confer app access; only use verified owned domains. */
 websiteUrl?:string|null;
};
/** Four featured brands, independent of connector status. Other brands remain registered in the catalog. */
export const FEATURED_COMPANY_KEYS=['salri','retro_ordinary','socialtopia','woven'] as const;
export const COMPANY_BRANDS:readonly CompanyBrand[]=[
 {key:'agentopia_web',name:'AgentOrdinary',asset:'/assets/agentordinary/agents-orb/agents-orb__default.webp',assetKind:'artwork',category:'AI workforce',initial:'A'},
 {key:'salri',name:'SALRI',asset:'/assets/agentordinary/brands/salri-corrected-20261013.webp',assetKind:'artwork',category:'Money & goals',initial:'S'},
 {key:'socialtopia',name:'SocialOrdinary',asset:'/assets/agentordinary/brands/socialordinary-corrected-20261013.webp',assetKind:'logo',category:'Social & publishing',initial:'S'},
 {key:'retro_ordinary',name:'RetroOrdinary',asset:'/assets/agentordinary/brands/retroordinary-corrected-20261013.webp',assetKind:'logo',category:'Parent company',initial:'R'},
 {key:'woven',name:'Woven',asset:'/assets/agentordinary/brands/woven-corrected-20261013.webp',assetKind:'artwork',category:'Fashion',initial:'W'},
 {key:'vip_club',name:'VIP Club',asset:'/assets/agentordinary/brands/vipclub.svg',assetKind:'logo',category:'Membership & fashion',initial:'V'},
] as const;
export function findCompanyBrand(key:string):CompanyBrand|undefined{
 return COMPANY_BRANDS.find(b=>b.key===key.toLowerCase());
}
